//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import loading from 'components/refreshData/loading.vue';
export default {
  props: {
    onRefresh: {
      type: Function,
      required: false
    }
  },
  data: function data() {
    return {
      defaultOffset: 40,
      // 默认高度, 相应的修改.releshMoudle的margin-top和.down-tip, .up-tip, .refresh-tip的height
      top: 0,
      scrollIsToTop: 0,
      startY: 0,
      isDropDown: false,
      // 是否下拉
      isRefreshing: false,
      // 是否正在刷新
      dropDownState: 1,
      // 显示1:下拉刷新, 2:松开刷新, 3:刷新中……
      dropDownStateText: {
        downTxt: '',
        downImg: '',
        upTxt: '松开刷新',
        upImg: 'release.png',
        refreshTxt: '刷新中...',
        refreshImg: 'refresh.gif'
      }
    };
  },
  components: {
    loading: loading
  },
  created: function created() {
    if (document.querySelector('.down-tip')) {
      // 获取不同手机的物理像素（dpr）,以便适配rem
      this.defaultOffset = document.querySelector('.down-tip').clientHeight || this.defaultOffset;
    }
  },
  methods: {
    touchStart: function touchStart(e) {
      this.startY = e.targetTouches[0].pageY;
    },
    touchMove: function touchMove(e) {
      this.scrollIsToTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop; // safari 获取scrollTop用window.pageYOffset

      if (e.targetTouches[0].pageY > this.startY) {
        // 下拉
        this.isDropDown = true;

        if (this.scrollIsToTop === 0 && !this.isRefreshing) {
          // 拉动的距离
          var diff = e.targetTouches[0].pageY - this.startY - this.scrollIsToTop;
          this.top = Math.pow(diff, 0.8) + (this.dropDownState === 3 ? this.defaultOffset : 0);

          if (this.top >= this.defaultOffset) {
            this.dropDownState = 2;
            e.preventDefault();
          } else {
            this.dropDownState = 1;
            e.preventDefault();
          }
        }
      } else {
        this.isDropDown = false;
        this.dropDownState = 1;
      }
    },
    touchEnd: function touchEnd(e) {
      if (this.isDropDown && !this.isRefreshing) {
        if (this.top >= this.defaultOffset) {
          // do refresh
          this.refresh();
          this.isRefreshing = true;
          console.log("do refresh");
        } else {
          // cancel refresh
          this.isRefreshing = false;
          this.isDropDown = false;
          this.dropDownState = 1;
          this.top = 0;
        }
      }
    },
    refresh: function refresh() {
      var _this = this;

      this.dropDownState = 3;
      this.top = this.defaultOffset;
      setTimeout(function () {
        _this.onRefresh(_this.refreshDone);
      }, 1200);
    },
    refreshDone: function refreshDone() {
      this.isRefreshing = false;
      this.isDropDown = false;
      this.dropDownState = 1;
      this.top = 0;
    }
  }
};